(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 992px)');

  function initSolutions() {
    var sections = document.querySelectorAll('section.solutions');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.__solutionsInited) return;
      section.__solutionsInited = true;

      var state = {
        items: Array.from(section.querySelectorAll('.solutions__item')),
        leftCol: section.querySelector('.solutions__col--left'),
        rightCol: section.querySelector('.solutions__col--right'),
        mobileWrapper: section.querySelector('.solutions__slides'),
        sliderEl: section.querySelector('.solutions__slider'),
        prevBtn: section.querySelector('.solutions__button--prev'),
        nextBtn: section.querySelector('.solutions__button--next'),
        swiper: null
      };

      section.__solutionsState = state;

      function toDesktop() {
        // Destroy swiper if exists
        if (state.swiper && typeof state.swiper.destroy === 'function') {
          try { state.swiper.destroy(true, true); } catch (e) {}
          state.swiper = null;
        }
        // Show desktop columns, hide mobile slider container
        var layoutEl = section.querySelector('.solutions__layout');
        var mobileEl = section.querySelector('.solutions__mobile');
        if (layoutEl) { layoutEl.hidden = false; layoutEl.setAttribute('aria-hidden', 'false'); }
        if (mobileEl) { mobileEl.hidden = true; mobileEl.setAttribute('aria-hidden', 'true'); }
        // Move items back to columns 1-2 left, 3-4 right by their data-index
        var byIndex = state.items.slice().sort(function (a, b) {
          return (+a.getAttribute('data-index') || 0) - (+b.getAttribute('data-index') || 0);
        });
        byIndex.forEach(function (item, idx) {
          item.classList.remove('swiper-slide');
          item.removeAttribute('role');
          if (idx < 2) {
            state.leftCol && state.leftCol.appendChild(item);
          } else {
            state.rightCol && state.rightCol.appendChild(item);
          }
        });
      }

      function toMobile() {
        // Hide desktop columns, show mobile slider container
        var layoutEl = section.querySelector('.solutions__layout');
        var mobileEl = section.querySelector('.solutions__mobile');
        if (layoutEl) { layoutEl.hidden = true; layoutEl.setAttribute('aria-hidden', 'true'); }
        if (mobileEl) { mobileEl.hidden = false; mobileEl.setAttribute('aria-hidden', 'false'); }
        // Move items to mobile slider wrapper in correct order and add swiper-slide class
        var byIndex = state.items.slice().sort(function (a, b) {
          return (+a.getAttribute('data-index') || 0) - (+b.getAttribute('data-index') || 0);
        });
        byIndex.forEach(function (item) {
          item.classList.add('swiper-slide');
          item.setAttribute('role', 'listitem');
          state.mobileWrapper && state.mobileWrapper.appendChild(item);
        });

        // Initialize swiper if available
        if (typeof Swiper !== 'undefined' && state.sliderEl) {
          state.swiper = new Swiper(state.sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            loop: false,
            a11y: true,
            navigation: {
              nextEl: state.nextBtn,
              prevEl: state.prevBtn
            }
          });
        }
      }

      function applyLayout() {
        if (MQ.matches) {
          toMobile();
        } else {
          toDesktop();
        }
      }

      // Initial apply
      applyLayout();

      // Watch for viewport changes (debounced)
      var resizeTimer;
      function onChange() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          applyLayout();
        }, 120);
      }

      if (MQ.addEventListener) {
        MQ.addEventListener('change', onChange);
      } else if (MQ.addListener) {
        MQ.addListener(onChange);
      }
      window.addEventListener('orientationchange', onChange);
    });
  }

  // Initialize on DOM ready and on Shopify section load (Theme Editor)
  document.addEventListener('DOMContentLoaded', initSolutions);
  document.addEventListener('shopify:section:load', initSolutions);
})();
